module.exports = "## Adjust your photo parameters\r\n\r\nNo matter how advanced your camera is, sometimes your photos still need a post-processing boost to bring out the details of the photo. You can use the Image Editor to adjust things like Brightness, Contrast, and saturation of your photos."


//////////////////
// WEBPACK FOOTER
// ./src/containers/Features/PhotoEditor/photo-editor-section-two.md
// module id = 1171
// module chunks = 0